export default __webpack_public_path__ + "static/media/bookroom.4ba755d6.png";